export enum EnModuleMode {
    list = 'list',
    singleRecord = 'singlerecord'
}
